import React from 'react';
import ReactDOM from 'react-dom';
import App from '../components/App'
import $ from 'jquery'
//import 'bootstrap/dist/css/bootstrap.min.css';
//import '../index.css'


if (module.hot) {
    module.hot.accept()
}

const Footer = () => (
    <footer className="footer">
        <div className="container-fluid">
            <span className="footer_text ">| © 2020 biswanathcommercecollege.in | Made by @Saurav</span>
        </div>
    </footer>
);


var rootElement = document.getElementById('root')

ReactDOM.render( [<App key="1" />, <Footer key="2" />], rootElement)